import React, { useMemo, useSyncExternalStore } from "react";

import { Link, useParams } from "react-router-dom";

import { getDataStore, getInstructeurById, countByDojo } from "@/data/dataStore.js";

import { EntityStatusBadge } from "@/components/DocumentVisibilityBadge.jsx";

import { DemoFlag } from "@/components/DemoBadge.jsx";

import { DemoNotice } from "@/components/DemoNotice.jsx";

import { PageSection } from "@/components/AppLayout.jsx";

import { EmptyState } from "@/coquille-bridge";

import { DataTable } from "@/components/DataTable.jsx";

import { usePublicCopy } from "@/i18n/karatePublicI18n.js";

import { useKarateUi } from "@/hooks/useKarateUi.js";



function useDataStore() {

  return useSyncExternalStore(

    (cb) => {

      window.addEventListener("karate-data-updated", cb);

      return () => window.removeEventListener("karate-data-updated", cb);

    },

    () => getDataStore(),

    () => getDataStore(),

  );

}



export function DojoDetailPage() {

  const { id } = useParams();

  const { copy } = usePublicCopy();

  const dd = copy.dojoDetail;

  const d = copy.directory;

  const { localizeDemo, demoBadge } = useKarateUi();

  const { dojos, etudiants } = useDataStore();

  const dojo = dojos.find((x) => x.id === id);



  const sensei = dojo?.sensei_id ? getInstructeurById(dojo.sensei_id) : null;

  const dojoStudents = useMemo(

    () => etudiants.filter((e) => e.dojo_id === id && e.statut !== "inactif"),

    [etudiants, id],

  );



  if (!dojo) {

    return (

      <PageSection title={dd.notFound} testId="page-dojo-detail-missing">

        <EmptyState message={dd.notFoundMessage} testId="dojo-detail-empty" />

        <p>

          <Link to="/dojos">{dd.backToList}</Link>

        </p>

      </PageSection>

    );

  }



  return (

    <PageSection

      title={localizeDemo(dojo.nom)}

      subtitle={dojo.demo ? dd.subtitleDemo : dd.subtitleOfficial}

      testId="page-dojo-detail"

    >

      {dojo.demo ? <DemoNotice variant="card" /> : null}



      <div className="detail-grid">

        <section className="detail-panel" data-testid="dojo-detail-info">

          <h2 className="section-h2">{dd.infoTitle}</h2>

          <dl className="info-dl detail-dl">

            <dt>{dd.id}</dt>

            <dd>{dojo.id}</dd>

            <dt>{d.columns.city}</dt>

            <dd>{localizeDemo(dojo.ville) || "—"}</dd>

            <dt>{d.columns.address}</dt>

            <dd>{localizeDemo(dojo.adresse) || "—"}</dd>

            <dt>{dd.phone}</dt>

            <dd>{dojo.telephone || "—"}</dd>

            <dt>{d.columns.email}</dt>

            <dd>{dojo.courriel || "—"}</dd>

            <dt>Sensei</dt>

            <dd>{sensei ? `${localizeDemo(sensei.nom)} (${sensei.titre})` : dd.unassigned}</dd>

            <dt>{d.columns.status}</dt>

            <dd>

              <EntityStatusBadge statut={dojo.statut} /> <DemoFlag demo={dojo.demo} />

            </dd>

            <dt>{dd.activeStudents}</dt>

            <dd>{countByDojo(dojo.id)}</dd>

          </dl>

        </section>



        <section className="detail-panel">

          <h2 className="section-h2">{dd.attachedStudents}</h2>

          {dojoStudents.length === 0 ? (

            <p className="muted">{dd.noStudents}</p>

          ) : (

            <DataTable

              rows={dojoStudents.map((e) => ({ ...e, nom_complet: `${e.prenom} ${e.nom}` }))}

              columns={[

                {

                  key: "nom_complet",

                  label: d.columns.name,

                  render: (r) => (

                    <>

                      {localizeDemo(r.prenom)} {localizeDemo(r.nom)}

                      {r.demo ? ` ${demoBadge}` : ""}

                    </>

                  ),

                },

                { key: "groupe", label: d.columns.group, render: (r) => localizeDemo(r.groupe) },

                { key: "ceinture", label: d.columns.belt, render: (r) => localizeDemo(r.ceinture) },

                {

                  key: "statut",

                  label: d.columns.status,

                  render: (r) => <EntityStatusBadge statut={r.statut} />,

                },

              ]}

              searchFields={["prenom", "nom", "groupe"]}

              testId="dojo-detail-students"

            />

          )}

        </section>

      </div>



      <p className="detail-back">

        <Link to="/dojos">{dd.backToList}</Link>

      </p>

    </PageSection>

  );

}


